// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "admin-261105-1/static/css/" + chunkId + "." + {"1285":"16ec5bf4","4456":"005758da","5364":"16ec5bf4","6445":"7a01ae87","6797":"7a01ae87","8068":"cce3ce18","8437":"1cc77895","9799":"005758da"}[chunkId] + ".chunk.css";
};